export default __webpack_public_path__ + "static/media/kwikstarter-transparent.5b5eed5b.png";